import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { spacing } from '@mobi/component-library/Foundations'

const enum LocalConstants {
  ExpandedButtonClass = 'js-expandable-btn--expanded',
}

// ****
// ONLY add buttons here that are used in BOTH BetSlip + Transacted
// ****

export const ShareButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ onClick, disabled, testId }, ref) => (
    <ButtonStyled
      ref={ref}
      size='xs'
      color='tertiary_grey'
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
    >
      <Icon name='LineShare02' size='1.6rem' />
      Share
    </ButtonStyled>
  )
)
ShareButton.displayName = 'ShareButton'

export const ExpandableContentButton: React.FC<
  Pick<ButtonProps, 'onClick' | 'disabled'> & { isExpanded: boolean; text?: string }
> = ({ onClick, disabled, isExpanded, text }) => (
  <ExpandableButtonStyled>
    <ButtonStyled
      size='xs'
      color='tertiary_grey'
      onClick={onClick}
      disabled={disabled}
      className={isExpanded ? LocalConstants.ExpandedButtonClass : ''}
    >
      <Icon size='1.6rem' name='SolidChevronDown' />{' '}
      {text ? `${isExpanded ? 'Hide' : 'See'} ${text}` : `See ${isExpanded ? 'Less' : 'More'}`}
    </ButtonStyled>
  </ExpandableButtonStyled>
)

// ======
// Styles
// ======

const ButtonStyled = styled(Button)({
  padding: `${spacing.smx1} ${spacing.smx2}`,
  gap: spacing.smx2,
})

const ExpandableButtonStyled = styled.span({
  '> button': {
    svg: { transition: 'transform ease 0.3s' },

    [`&.${LocalConstants.ExpandedButtonClass} svg`]: { transform: 'rotate(-180deg)' },
  },
})

// =====
// Types
// =====

type ButtonProps = Pick<React.ComponentProps<typeof Button>, 'onClick' | 'disabled'> & {
  testId?: string
}
